import { render, staticRenderFns } from "./reminder.vue?vue&type=template&id=690609a6&scoped=true&"
import script from "./reminder.vue?vue&type=script&lang=js&"
export * from "./reminder.vue?vue&type=script&lang=js&"
import style0 from "./reminder.css?vue&type=style&index=0&id=690609a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690609a6",
  null
  
)

export default component.exports